import React, { useEffect } from "react"
import { graphql, PageProps } from "gatsby"

import { Layout } from "@interia/common/components/layout"
import Seo from "../../components/seo/seo"
import { DownloadableAssets, PaginationPosts, Specialist } from "../../components/sections"
import useMainMenu from "../../hooks/useMainMenu"
import usePostsPageData from "../../hooks/usePostsPageData"
import styled from "styled-components"
import { Section } from "@interia/common/components/section"
import { H2 } from "@interia/common/components/typography"
import { palette } from "@interia/common/styles/global"
import { StaticImage } from "gatsby-plugin-image"
import usePosts from "../../hooks/usePosts"
import useFooter from "../../hooks/useFooter"

export const Wrapper = styled.section`
  padding:  2rem 7vw 2rem 7vw;
  display: flex;
  position: relative;
  z-index: 5;
`

export const Title = styled.h1`
  color: ${palette.white};
  font-size: 3.75rem;
  letter-spacing: -1.2px;
  font-weight: 300;
  line-height: 1;
`

export const Background = styled.div`
 position: absolute;
 z-index: -3;
 top:0;
 left:0;
 height:100%;
 width: 100%;
`


type DataProps = {
  params: {

  }
  site: {
    siteMetadata: {
      title: string
    }
  }
}

const AktualnosciPage = ({ data: { site }, params }: PageProps<DataProps>) => {
  const siteTitle = site.siteMetadata.title
  const { openGraph, specialist } = usePostsPageData()
  const posts = usePosts("aktualnosci")
  const menuItems = useMainMenu()
  const page = params[`*`] ? parseInt(params[`*`].split(',').pop() ?? '') : 1
  const footer = useFooter()


  return (
    <Layout gemiusId='0nKacee.fzah6lJ8915YdYZR7FlRDyyXVPlG5jJtFhH.P7' footer={footer} logoUrl={{ external: false, url: '/' }} menuItems={menuItems} actualSite="dla-mediow">
      <Seo title={siteTitle} openGraph={openGraph} />
      <Wrapper>
        <Title>Aktualności</Title>
        <Background>
          <StaticImage
            style={{ height: '100%', width: '100%' }}
            src="../../../static/mission-background.png"
            placeholder="blurred"
            formats={["auto", "webp"]}
            alt="O nas"
            title="O nas"
            quality={100}
            loading="eager"
          />
        </Background>
      </Wrapper>
      <PaginationPosts page={page} posts={posts} />
      {specialist.active && <Specialist mediacontact={specialist.mediacontact} cooperation={specialist.cooperation} />}
    </Layout>
  )
}

export default AktualnosciPage

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
  }
`
